/**
 * Brand date picker for the private-events form's date field.
 *
 * Uses the vendored flatpickr (assets/flatpickr.min.*) so the calendar popup is
 * fully styled (assets/datepicker.css) and easier to use than the native date
 * control. The field stays a normal text input that submits a readable date
 * string (e.g. "June 15, 2026"); disableMobile keeps the same styled calendar
 * on phones instead of falling back to the OS picker.
 */
(function () {
  if (typeof window.flatpickr !== 'function') return;

  var mobileQuery = window.matchMedia('(max-width: 540px)');

  function fitCalendarOnMobile(instance) {
    if (!mobileQuery.matches) return;
    var cal = instance.calendarContainer;
    var calWidth = cal.offsetWidth;
    var calHeight = cal.offsetHeight;
    var left = Math.max(16, (window.innerWidth - calWidth) / 2);
    cal.style.left = left + 'px';
    cal.style.right = 'auto';

    var top = parseFloat(cal.style.top) || cal.getBoundingClientRect().top;
    if (top + calHeight > window.innerHeight - 16) {
      top = Math.max(16, window.innerHeight - calHeight - 16);
      cal.style.top = top + 'px';
    }
  }

  window.flatpickr('.private-events-form__input--date', {
    dateFormat: 'F j, Y',
    minDate: 'today',
    disableMobile: true,
    onOpen: function (_selectedDates, _dateStr, instance) {
      fitCalendarOnMobile(instance);
    }
  });
})();
